/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminUpdateProxiesOptions, AdminUpdateProxiesStatus200, AdminUpdateProxiesStatus422 } from '../models/AdminUpdateProxies'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { adminUpdateProxies } from '../clients/axios/adminUpdateProxies'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const adminUpdateProxiesMutationKey = () => [{ url: '/admin/org/:org_id/proxy' }] as const

export function adminUpdateProxiesMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = adminUpdateProxiesMutationKey()
  return mutationOptions<AdminUpdateProxiesStatus200, ResponseErrorConfig<AdminUpdateProxiesStatus422>, AdminUpdateProxiesOptions, TContext>({
    mutationKey,
    mutationFn: async({ path, body }) => {
      return await adminUpdateProxies({ ...config, path, body, throwOnError: true })
    },
  })
}

/**
 * @description Update the org's proxy configuration.
 * @summary Update Org Proxies
 * {@link /admin/org/:org_id/proxy}
 */
export function useAdminUpdateProxies<TContext>(options: {
  mutation?: UseMutationOptions<AdminUpdateProxiesStatus200, ResponseErrorConfig<AdminUpdateProxiesStatus422>, AdminUpdateProxiesOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? adminUpdateProxiesMutationKey()

  const baseOptions = adminUpdateProxiesMutationOptions(config) as UseMutationOptions<AdminUpdateProxiesStatus200, ResponseErrorConfig<AdminUpdateProxiesStatus422>, AdminUpdateProxiesOptions, TContext>

  return useMutation<AdminUpdateProxiesStatus200, ResponseErrorConfig<AdminUpdateProxiesStatus422>, AdminUpdateProxiesOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<AdminUpdateProxiesStatus200, ResponseErrorConfig<AdminUpdateProxiesStatus422>, AdminUpdateProxiesOptions, TContext>
}
